/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GenderEnum } from './GenderEnum';
import {
    GenderEnumFromJSON,
    GenderEnumFromJSONTyped,
    GenderEnumToJSON,
    GenderEnumToJSONTyped,
} from './GenderEnum';

/**
 * Response for get last patients request
 * @export
 * @interface LastPatientsResponse
 */
export interface LastPatientsResponse {
    /**
     * Unique identifier of the patient
     * @type {string}
     * @memberof LastPatientsResponse
     */
    patientId?: string;
    /**
     * Unique identifier of the relation
     * @type {string}
     * @memberof LastPatientsResponse
     */
    relationId?: string;
    /**
     * Firstname of patient
     * @type {string}
     * @memberof LastPatientsResponse
     */
    firstname?: string;
    /**
     * Lastname of patient
     * @type {string}
     * @memberof LastPatientsResponse
     */
    lastname?: string;
    /**
     * Birthdate of patient
     * @type {string}
     * @memberof LastPatientsResponse
     */
    birthdate?: string;
    /**
     * Datetime of last visit
     * @type {string}
     * @memberof LastPatientsResponse
     */
    lastVisitDateTime?: string;
    /**
     * 
     * @type {GenderEnum}
     * @memberof LastPatientsResponse
     */
    gender?: GenderEnum;
}



/**
 * Check if a given object implements the LastPatientsResponse interface.
 */
export function instanceOfLastPatientsResponse(value: object): value is LastPatientsResponse {
    return true;
}

export function LastPatientsResponseFromJSON(json: any): LastPatientsResponse {
    return LastPatientsResponseFromJSONTyped(json, false);
}

export function LastPatientsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LastPatientsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'] == null ? undefined : json['patientId'],
        'relationId': json['relationId'] == null ? undefined : json['relationId'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
        'birthdate': json['birthdate'] == null ? undefined : json['birthdate'],
        'lastVisitDateTime': json['lastVisitDateTime'] == null ? undefined : json['lastVisitDateTime'],
        'gender': json['gender'] == null ? undefined : GenderEnumFromJSON(json['gender']),
    };
}

export function LastPatientsResponseToJSON(json: any): LastPatientsResponse {
    return LastPatientsResponseToJSONTyped(json, false);
}

export function LastPatientsResponseToJSONTyped(value?: LastPatientsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'relationId': value['relationId'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'birthdate': value['birthdate'],
        'lastVisitDateTime': value['lastVisitDateTime'],
        'gender': GenderEnumToJSON(value['gender']),
    };
}

